import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { VApp, VMain, VAppBar, VAppBarNavIcon, VToolbarTitle, VNavigationDrawer, VContainer, VList, VListItem, VListItemTitle, VListItemContent, VSubheader, VDivider } from "vuetify/lib";
export default /*#__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const title = ref("Begento UI");
        const drawer = ref(false);
        const navItems = [
            {
                title: "Buttons",
                items: [
                    { title: "Buttons", to: "/" },
                    { title: "Icon Button", to: "/icon-button" },
                ],
            },
            {
                title: "Form",
                items: [
                    { title: "Autocomplete", to: "/autocomplete" },
                    { title: "Inputs", to: "/inputs" },
                    { title: "Checkbox", to: "/checkbox" },
                    { title: "Radio", to: "/radio" },
                    { title: "Switch", to: "/switch" },
                ],
            },
            {
                title: "Wrappers",
                items: [
                    { title: "Chip", to: "/chip" },
                    { title: "Chip List", to: "/chip-list" },
                    { title: "Expansion Panel", to: "/expansion-panel" },
                    { title: "Form Dialog", to: "/form-dialog" },
                    { title: "List", to: "/list" },
                    { title: "Tooltip", to: "/tooltip" },
                    { title: "Table", to: "/table" },
                    { title: "Menu", to: "/menu" },
                    { title: "Toolbar", to: "/toolbar" },
                ],
            },
            {
                title: "Navigation",
                items: [
                    { title: "Tabs", to: "/tabs" },
                ],
            },
            {
                title: "Feedback",
                items: [
                    { title: "Progress Circular", to: "/progress-circular" },
                    { title: "Progress Linear", to: "/progress-linear" },
                ],
            },
            {
                title: "Images & Icons",
                items: [
                    { title: "Avatar", to: "/avatar" },
                    { title: "Icon", to: "/icon" },
                    { title: "Image", to: "/image" },
                ],
            },
            {
                title: "Icons System",
                items: [
                    { title: "Icon Catalog", to: "/icons/catalog" },
                ],
            },
        ];
        const handleClick = () => {
            console.log("Botón BeosButton clickeado");
        };
        return { __sfc: true, title, drawer, navItems, handleClick, VApp, VMain, VAppBar, VAppBarNavIcon, VToolbarTitle, VNavigationDrawer, VContainer, VList, VListItem, VListItemTitle, VListItemContent, VSubheader, VDivider };
    }
});
